export type Seat = 'floor' | 'camera' | 'tv';

export interface RoomClaim {
  roomId: string;
  code: string;
  seat: Seat;
  token: string;
  expiresAt: number;
}

async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { 'content-type': 'application/json', ...init?.headers },
  });
  const body = (await response.json()) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? `Request failed (${response.status})`);
  return body;
}

export const createRoom = (): Promise<RoomClaim> => api('/api/rooms', { method: 'POST', body: '{}' });

export const joinRoom = (code: string, seat: 'camera' | 'tv'): Promise<RoomClaim> =>
  api('/api/rooms/join', { method: 'POST', body: JSON.stringify({ code, seat }) });
